// extracted by mini-css-extract-plugin
export var closed = "_ax-1";
export var resizer = "_ax-0";